import { render, staticRenderFns } from "./ItemViewsDepTable.vue?vue&type=template&id=4a9d9d24&"
import script from "./ItemViewsDepTable.vue?vue&type=script&lang=js&"
export * from "./ItemViewsDepTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports